module.exports = __webpack_public_path__ + "static/0017-5db0f8ad8ba4868e109616388f36871d.png";